import { useEffect, useState } from "react";
import api from "../lib/api";
import { ExternalLink } from "lucide-react";

export default function BannerSlot({ placement = "homepage_top" }) {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    api.get("/banners", { params: { placement } })
      .then(r => setBanners(r.data))
      .catch(() => {});
  }, [placement]);

  if (!banners.length) return null;

  const b = banners[0];
  const isDark = placement === "footer";

  return (
    <a
      href={b.cta_url}
      target="_blank"
      rel="noreferrer"
      className="block group"
      data-testid={`banner-${placement}`}
    >
      <div className={`p-6 md:p-7 rounded-2xl border ${isDark ? "border-white/20 bg-white/5" : "sponsor-banner"} flex flex-col md:flex-row md:items-center gap-4 md:gap-8 transition-all hover:-translate-y-0.5`}>
        <div className={`text-[11px] font-semibold uppercase tracking-wider ${isDark ? "text-white/60" : "text-[#4b5468]"} shrink-0`}>
          Corporate Sponsor
        </div>
        <div className="flex-1">
          <div className={`display-black text-xl md:text-2xl ${isDark ? "text-white" : "text-[#0b1020]"}`}>
            {b.headline}
          </div>
          <div className={`text-sm ${isDark ? "text-white/75" : "text-[#4b5468]"} mt-1 leading-relaxed`}>{b.body}</div>
          <div className={`text-[12px] mt-2 font-medium ${isDark ? "text-white/50" : "text-[#4b5468]"}`}>
            — {b.sponsor}
          </div>
        </div>
        <div className={`shrink-0 inline-flex items-center gap-2 ${isDark ? "text-[#fde4b6]" : "text-[#f43f5e]"} font-semibold text-[13px] group-hover:gap-3 transition-all`}>
          {b.cta_text} <ExternalLink className="w-3.5 h-3.5" />
        </div>
      </div>
    </a>
  );
}
